<template>
  <v-app id="inspire">
    <v-main>
      <v-container class="fill-height pa-0"
                   fluid
                   :style="`background-image: url('${backgroundImage}'); background-position: center center; background-size: cover;`">
        <v-col offset-sm="1" sm="10">
          <v-row justify="center">
            <v-col cols="12" sm="8" md="6">
              <v-card  fill-height class="elevation-12" color="color" >
                <v-col class="d-flex justify-center">
                  <v-avatar size="200" max-height="100px" tile>
                    <v-img :src="logoImage" height="100%" contain />
                  </v-avatar>
                </v-col>
                <v-card-text>
                  <v-alert  color="primary" text >
                    <p class="text-wrap" style="word-break: break-all;">
                      A URL de Login <a  :href="nome">{{ nome }}</a> não é válida. <br />
                      Corrija a URL de Login ou contate o Administrador.
                    </p>
                  </v-alert>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  metaInfo: {
    title: window.env.VUE_APP_NOME + ' - Parceiro não Identificado'
  },
  data () {
    return {
      logoImage: this.$theme.logo || '/assets/imgs/logo.png',
      backgroundImage: this.$theme.background || '/assets/imgs/background.png',
      nome: 'https://' + process.env.VUE_APP_CUSTOMIZACAO + '.' + process.env.VUE_APP_ROOT + 'partner/' + localStorage.ambiente
    }
  },
  computed: {
    color: function () {
      return this.$theme.dark ? '#0000007A' : '#FFFFFFCA'
    }
  }
}
</script>
